import React, { useState, useRef, useEffect } from "react";
import closeIcon from "../../Assets/Icons/close.png";
import Input from "../../Components/Input";
import Dropdown from "../../Components/Dropdown";
import DateInput from "../../Components/DateInput";
import searchIcon from "../../Assets/Icons/search.png";
import Loader from "../../Components/Loader";
import { postData } from "../../ApiServices/ApiService";
import { logFrontendException } from "../../Utils/Exception";
import TextInput from "../../Components/TextInput";
import { ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_ADD_EXCEPTION, ORG_EXPENSE_TYPE_DD, 
    ORG_EXPENSE_EDIT_DEL_APPROVE, ORG_INVOICE, ORG_EXPENSE_OPENING_CRUD } from "../../ApiServices/BaseURL";
import DeleteConfirmationModal from "../../Components/Modals/DeleteConformationModal";
import approveIcon from "../../Assets/Icons/approve.png";
import rejectIcon from "../../Assets/Icons/reject.png";
import approvedIcon from "../../Assets/Icons/circle-tick.png";
import rejectedIcon from "../../Assets/Icons/rejected.png";
import { convertGMTToLocal } from "../../Utils/Validation";
import { useTheme } from "../../GlobalContext/GlobalContext";
import useConditionalOverflow from "../../Components/useConditionalOverflow";

const AddExpenseModal = ({ isOpen, onClose, editData, onValueChange }) => {
    const createNewExpense = () => ({
        uid: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
        nature: null,
        type: null,
        date: "",
        billed: null,
        client: null,
        clientSearch: "",
        amount: "",
        file: null,
        uploaded: false,
        base64File: '',
        fileExtension: '',
        clientList: [],
        clientLoading: false,
        clientError: "",
        approvedAmount: null,
        approvedStatus: null,
        expense_status_name: '',
        group_exp_id: null,
    });

    const modalRef = useRef(null);
    // const shouldScroll = useConditionalOverflow(modalRef, 0.9); // 90% threshold
    const [shouldScroll, setShouldScroll] = useState(false);
    const { setIsLoginPopup } = useTheme();
    const [form, setForm] = useState({ name: "", comment: "" });
    const [expenses, setExpenses] = useState([createNewExpense()]);
    const [submitSuccess, setSubmitSuccess] = useState('')
    const [submitError, setSubmitError] = useState('')

    const [errors, setErrors] = useState({});
    const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);


    const pageName = 'AddExpenseModal';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const expenseTypeOptions = [
        { label: "Expense for Self", value: "self" },
        { label: "Expense for Client", value: "client" },
    ];
    const yesNoOptions = [
        { label: "Yes", value: true },
        { label: "No", value: false },
    ];

    const [expenseLoading, setExpenseLoading] = useState(false);
    const [expenseTypeerror, setExpenseTypeError] = useState('');
    const [expenseTypeList, setExpenseTypeList] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [gstValueInfo, setGstValueInfo] = useState({
        "series_type": 0
    });
    const [gstValueInfoLoading, setGstValueInfoLoading] = useState(false);
    const [gstValueInfoError, setGstValueInfoError] = useState('');

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        console.log('dropdownName:-', dropdownName)
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    let overallStatus = '';
    useEffect(() => {
        const checkHeight = () => {
            const viewportHeight = window.innerHeight;
            if (modalRef.current) {
                console.log('modalRef.current?.offsetHeight:-', modalRef.current?.offsetHeight)

                const modalHeight = modalRef.current?.offsetHeight;
                setShouldScroll(modalHeight >= viewportHeight * 0.9);
            } else {
                console.log('else--modalRef.current?.offsetHeight:-', modalRef.current?.offsetHeight)
            }
        };



        checkHeight();
        // window.addEventListener('resize', checkHeight);

        // return () => window.removeEventListener('resize', checkHeight);
    }, [modalRef, expenses]);

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {

            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) =>
                    dropdownRefs.current[key] === null ||  // Ignore null values
                    (dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target))
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };


        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        setOpenDropdown(openDropdown);
    }, [openDropdown])

    useEffect(() => {
        console.log('expenselist',editData);
        fetchExpenceTypeList();
        // if(!editData) {
            getExpenseOpeningInfo();
        // }
    }, [])

    // Run resetForm when modal closes
    useEffect(() => {
        if (!isOpen) {
            resetForm();
        }
    }, [isOpen]);

    const resetForm = () => {
        console.log('reset fileds')
    }
    useEffect(() => {
        console.log('editData 1',editData);
        if (editData) {
            setForm({
                name: editData?.expense_name || '',
                comment: editData?.comment || ''
            });
            const expenseRows = (editData?.expenses || []).map(item => ({
                uid: item?.id || `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
                expenseUid: item?.id,
                nature: { label: item?.nature_of_expense_name, value: item?.nature_of_expense_id || 0 },
                type: expenseTypeOptions?.find(opt => opt.value === item?.expense_type) || null,
                date: item?.expense_date,
                billed: yesNoOptions.find(opt => opt.value === item?.billed_to_client),
                client: item?.client_id,
                clientSearch: item?.client_name || '',
                amount: Number(item?.amount),
                uploaded: !!item?.receipt_url,
                file: item?.receipt_url || null,
                base64File: item?.receipt_url || '',
                fileExtension: '',
                clientList: [],
                clientLoading: false,
                clientError: '',
                approvedAmount: Number(item?.approved_amount) || null,
                expense_status_name: String(item?.expense_status_name) || '',
                approvedStatus: null,
                group_exp_id: item?.group_exp_id
            }));

            setExpenses(expenseRows);
        }
    }, [editData, expenseTypeList]);

    useEffect(() => {
        console.log('editData',editData);
        // get series config info while approving
        if (editData?.pageType === 'approve') {
            fetchGstValueInfo();
        }
    }, [editData])


    const fetchGstValueInfo = async () => {
        try {
            setGstValueInfoLoading(true);
            setGstValueInfoError('');
            setGstValueInfo({});


            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                "action": "GET_CONFIG_TAX_INFO",
                "emp_id_auth": storedUserInfo?.emp_id,
                "series_for": "INVOICE"
            }

            // Make the API call
            const response = await postData(ORG_INVOICE, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setGstValueInfo(responseData?.dataJ[0]);
                            if (!responseData?.dataJ[0]?.series_type) {
                                setGstValueInfoError('Invoice Series Not Configured in Invoice Settings')
                            }
                        } else {
                            setGstValueInfoError(responseData?.info || 'Configured Invoice Series Not Available');
                            logFrontendException(storedUserId, pageName, "fetchGstValueInfo", responseData || '');
                        }
                    } else {
                        setGstValueInfoError(responseData?.info || 'Failed to fetch Invoice Series configured. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchGstValueInfo", responseData || '');
                    }
                } else {
                    setGstValueInfoError(responseData?.info || 'Failed to fetch Invoice Series configured.');
                    logFrontendException(storedUserId, pageName, "fetchGstValueInfo", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setGstValueInfoError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUserId, pageName, "fetchGstValueInfo-Unauthorized", response || '');
            } else {
                setGstValueInfoError('Error while fetching Invoice Series configured');
                logFrontendException(storedUserId, pageName, "fetchGstValueInfo", response || '');
            }
        } catch (error) {
            setGstValueInfoError(`Failed to fetch Invoice Series configured. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchGstValueInfo-catch", error || '');

        } finally {
            setGstValueInfoLoading(false);
        }
    }


    const fetchExpenceTypeList = async () => {
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                "emp_id_auth": storedUserInfo?.emp_id,
            };
            setExpenseTypeError('')
            setExpenseLoading(true);
            const response = await postData(ORG_EXPENSE_TYPE_DD, payload);
            const responseData = await response.json();

            if (response.status === 200 && responseData.statusCode === 200) {
                if (responseData.message.toLowerCase() === "success") {
                    if (responseData?.dataJ?.length > 0) {
                        const filterData = responseData?.dataJ.map(service => ({
                            label: service?.name,
                            value: service?.id
                        }));
                        setExpenseTypeList(filterData)
                    } else {
                        setExpenseTypeError(responseData?.info || "Failed to fetch expense type.");
                        //  Log exception to backend (User Id,Page Name,Method Name,Response)
                        logFrontendException(storedUserId, pageName, "fetchExpenceTypeList", responseData || '');

                    }
                } else {
                    setExpenseTypeError(responseData?.info || "Failed to fetch expense type.");
                    //  Log exception to backend (User Id,Page Name,Method Name,Response)
                    logFrontendException(storedUserId, pageName, "fetchExpenceTypeList", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setExpenseTypeError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "fetchExpenceTypeList", responseData || '');

            } else {
                setExpenseTypeError(responseData?.info || "Failed to fetch expense type.");
                //  Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "fetchExpenceTypeList", responseData || response || '');
            }
        } catch (err) {
            setExpenseTypeError("Failed to fetch expense type.");
            //  Log exception to backend (User Id,Page Name,Method Name,Response)
            logFrontendException(storedUserId, pageName, "fetchExpenceTypeList-catch", err || '');
        } finally {
            setExpenseLoading(false);
        }
    }

    const handleExpenseChangeByUid = (uid, key, value) => {
        setExpenses((prev) =>
            prev.map((row) => {
                if (row.uid !== uid) return row;

                const updatedRow = { ...row };

                // Reset related fields when clientSearch is updated
                if (key === "clientSearch") {
                    updatedRow.clientSearch = value;
                    updatedRow.client = null;
                    updatedRow.clientList = [];
                    updatedRow.clientError = "";
                }
                // Reset related fields when billed is updated
                else if (key === "billed") {
                    updatedRow.billed = value;
                    updatedRow.clientSearch = '';
                    updatedRow.client = null;
                    updatedRow.clientList = [];
                    updatedRow.clientError = "";
                }
                // Handle approvedAmount
                else if (key === "approvedAmount") {
                    const amount = parseFloat(value);
                    updatedRow.approvedAmount = (value === "" || value === null) ? null : value;
                    updatedRow.approvedStatus = !isNaN(amount) && amount === 0 ? false : !isNaN(amount) && amount > 0 ? true : null;
                }
                // If approvedStatus is true, auto-set approvedAmount to row.amount or keep as is
                else if (key === "approvedStatus" && value) {
                    // console.log('approvedStatus:-',value,'approvedAmount:-',Number(updatedRow?.approvedAmount))
                    updatedRow.approvedStatus = value;
                    updatedRow.approvedAmount = Number(updatedRow?.approvedAmount) ? Number(updatedRow?.approvedAmount) : Number(updatedRow?.amount);
                        // Clear approvedAmount error if status is changed
                        if (updatedRow.rowErrors) {
                            delete updatedRow.rowErrors.approvedAmount;
                        }
                }
                // If approvedStatus is false, auto-set approvedAmount to 0
                else if (key === "approvedStatus" && !value) {
                    updatedRow.approvedStatus = value;
                    updatedRow.approvedAmount = 0;
                        // Clear approvedAmount error if status is changed
                        if (updatedRow.rowErrors) {
                            delete updatedRow.rowErrors.approvedAmount;
                        }
                }
                // Update any other field
                else {
                    updatedRow[key] = value;
                }

                // Clear corresponding rowErrors if valid input is given
                if (updatedRow.rowErrors) {
                    if (key === "nature" && value) delete updatedRow.rowErrors.nature;
                    if (key === "type" && value) delete updatedRow.rowErrors.type;
                    if (key === "date" && value) delete updatedRow.rowErrors.date;
                    if (key === "billed" && value) delete updatedRow.rowErrors.billed;
                    if (key === "clientSearch" && value) delete updatedRow.rowErrors.clientSearch;
                    if (key === "amount" && value && !isNaN(value)) delete updatedRow.rowErrors.amount;
                    if (key === "approvedAmount" && value !== null && !isNaN(value)) delete updatedRow.rowErrors.approvedAmount;
                    if (key === "approvedStatus" && value !== null) delete updatedRow.rowErrors.approvedStatus;
                }

                return updatedRow;
            })
        );
            // After updating, check if ALL approvedStatus are null or undefined
    setTimeout(() => {
        const allStatusesEmpty = expenses.every(exp => exp.approvedStatus === null || exp.approvedStatus === undefined);
        console.log('allStatusesEmpty:',allStatusesEmpty)
        if (allStatusesEmpty) {
            setSubmitError('');
        }
    }, 0); // Schedule after state update
    };

    const [expenseOpeningInfo, setExpenseOpeningInfo] = useState(null);
    const [expenseOpeningInfoLoading, setExpenseOpeningInfoLoading] = useState(false);
    const [expenseOpeningInfoError, setExpenseOpeningInfoError] = useState('');
    const [isExpOpeningBalAvailable, setIsExpOpeningBalAvailable] = useState(false);

    const getExpenseOpeningInfo = async () => {
        try {
            setExpenseOpeningInfo(null);
            setExpenseOpeningInfoError('')
            setExpenseOpeningInfoLoading(true);
            setIsExpOpeningBalAvailable(false);

            // Retrieve user information (e.g., emp_id)
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Constructing payload for the API call
            const payload = {
                "action_type": "get_expense_opening_bal_info",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            console.log('Payload for Exp Opening Configuration:', payload);

            // Make the API call
            const response = await postData(ORG_EXPENSE_OPENING_CRUD, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        console.log('responseData', responseData, responseData?.dataJ?.length)
                        if (responseData?.dataJ?.length > 0) {
                            setExpenseOpeningInfo(responseData?.dataJ[0]);
                            setIsExpOpeningBalAvailable(true);
                        } else {
                            setExpenseOpeningInfoError('Expense Management Opening Balance is not configured. Please contact your Admin to set it up before submitting any expenses.');
                            logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData?.info || '');
                        }
                    } else {
                        setExpenseOpeningInfoError(responseData?.info || 'Failed to get books opening balance.');
                        logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData?.info || '');
                    }
                } else {
                    setExpenseOpeningInfoError(responseData?.info || 'Error while getting books opening balance.');
                    logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setExpenseOpeningInfoError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData || '');
                setIsLoginPopup(true)
            } else {
                setExpenseOpeningInfoError('Failed to get books opening balance. Please try again.');
                logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", response || '');
            }
        } catch (error) {
            setExpenseOpeningInfoError(`Failed to get books opening balance. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", error || '');
        } finally {
            setExpenseOpeningInfoLoading(false);
        }
    };






    const handleFileUpload = (uid, file) => {
        const maxFileSize = 2 * 1024 * 1024; // 2MB

        if (file.size > maxFileSize) {
            alert("File size exceeds the maximum limit of 2MB.");
            return;
        }

        const reader = new FileReader();

        reader.onload = () => {
            try {
                const base64String = reader.result.split(',')[1]; // Extract Base64 string

                const updated = expenses.map((item) =>
                    item.uid === uid
                        ? {
                            ...item,
                            file: file,
                            uploaded: true,
                            base64File: base64String,
                            fileExtension: file.name.split('.').pop()
                        }
                        : item
                );

                setExpenses(updated);
            } catch (parseError) {
                console.error("Error parsing file to Base64:", parseError);
                alert("Failed to process the file. Please try again.");
            }
        };

        reader.onerror = (error) => {
            console.error("Error reading file:", error);
            alert("Failed to read the file. Please try again.");
        };

        reader.readAsDataURL(file); // Trigger Base64 conversion
    };


    const handleAddRow = () => {
        setExpenses([...expenses, createNewExpense()]);
    };

    const total = expenses.reduce(
        (sum, row) => sum + parseFloat(row.amount || 0),
        0
    );

    const approvedTotal = expenses.reduce(
        (sum, row) => sum + parseFloat(row.approvedAmount || 0),
        0
    );


    const validateForm = () => {
        const newErrors = {};
        const updatedExpenses = [];

        if (!form.name || form.name.trim() === "") {
            newErrors.name = "Expense Name is required.";
        } else if (form.name.length > 20) {
            newErrors.name = "Maximum 20 characters allowed.";
        }

        if (form.comment && form.comment.length > 30) {
            newErrors.comment = "Maximum 30 characters allowed.";
        }

        let hasRowErrors = false;

        const validatedExpenses = expenses.map((row) => {
            const rowErrors = {};

            if (!row.nature) {
                rowErrors.nature = "Nature of Expense is required.";
                hasRowErrors = true;
            }

            if (!row.type) {
                rowErrors.type = "Expense Type is required.";
                hasRowErrors = true;
            }

            if (!row.date) {
                rowErrors.date = "Expense Date is required.";
                hasRowErrors = true;
            }

            if (!row.billed) {
                rowErrors.billed = "Billed to Client is Required";
                hasRowErrors = true;
            }

            if (row.billed?.value && !row.client) {
                rowErrors.clientSearch = "Select a client";
                hasRowErrors = true;
            }

            if (!row.amount || isNaN(row.amount)) {
                rowErrors.amount = "Enter a valid amount";
                hasRowErrors = true;
            }

            if (editData?.pageType === 'approve') {
                if (row.approvedStatus === null || row.approvedStatus === undefined) {
                    setSubmitError('Please review each expense row and mark it as either Approved (✓) or Rejected (×) before submitting.');
                    hasRowErrors = true;
                }

                const approvedAmountValue = Number(row.approvedAmount);
                const rowAmountValue = Number(row.amount);

                if (
                    row.approvedAmount === null ||
                    row.approvedAmount === undefined ||
                    isNaN(approvedAmountValue) ||
                    approvedAmountValue < 0 ||
                    approvedAmountValue > rowAmountValue
                ) {
                    rowErrors.approvedAmount = "Approved amount should be 0 or less than or equal to the original amount.";
                    hasRowErrors = true;
                }
            }




            updatedExpenses.push({ ...row, rowErrors });
            return { ...row, rowErrors };
        });

        setErrors(newErrors);
        setExpenses(validatedExpenses);

        return Object.keys(newErrors).length === 0 && !hasRowErrors;
    };


    const handleSubmit = async () => {
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            var payload = null

            if (editData?.pageType === 'edit') {
                payload = {
                    "action": "edit",
                    "emp_id_auth": storedUserInfo?.emp_id,
                    "expenses": expenses.map((row) => ({
                        id: row?.expenseUid || null,
                        name: form?.name,
                        comment: form?.comment,
                        nature_of_expense_id: row?.nature?.value,
                        expense_type: row?.type?.value,
                        expense_date: row?.date,
                        billed_to_client: row?.billed?.value,
                        client_id: row?.client,
                        amount: Number(row?.amount),
                        receipt_url: row?.base64File,
                        file_extension: row?.fileExtension,
                        group_exp_id: row?.group_exp_id

                    })),
                };
            } else if (editData?.pageType === 'approve') {
                console.log('gstValueInfo', gstValueInfo, 'gstValueInfoError', gstValueInfoError);
                //  Check if any approved & billed_to_client == true
                const hasBilledApproved = expenses.some(
                    (row) =>
                        row?.approvedStatus === true &&
                        row?.billed?.value === true
                );

                // If true and invalid invoice series, show error and exit
                if (hasBilledApproved && (gstValueInfo?.series_type === 0 || gstValueInfoError !== '')) {
                    setSubmitError(gstValueInfoError);
                    return;
                }
                payload = {
                    action: "approve",
                    emp_id_auth: storedUserInfo?.emp_id,
                    expenses: expenses.map((row) => {
                        let approved_status = 0;

                        if (row?.approvedStatus === false) {
                            approved_status = 3; // Rejected
                        } else if (row?.approvedStatus === true) {
                            if (Number(row?.approvedAmount) === Number(row?.amount)) {
                                approved_status = 2; // Fully Approved
                            } else if (Number(row?.approvedAmount) < Number(row?.amount)) {
                                approved_status = 4; // Partially Approved
                            }
                        }

                        return {
                            id: row?.expenseUid || null,
                            approved_amount: Number(row?.approvedAmount),
                            approved_status: approved_status,
                            billed_to_client: row?.billed?.value,
                            client_id: row?.client
                        };
                    }),
                };

            } else {
                payload = {
                    "emp_id_auth": storedUserInfo?.emp_id,
                    "expenses": expenses.map((row) => ({
                        name: form?.name,
                        comment: form?.comment,
                        nature_of_expense_id: row?.nature?.value,
                        expense_type: row?.type?.value,
                        expense_date: row?.date,
                        billed_to_client: row?.billed?.value,
                        client_id: row?.client,
                        amount: Number(row?.amount),
                        receipt_url: row?.base64File,
                        // receipt: row.file ? row.file.name : null,
                        // base64: row?.base64File,
                        file_extension: row?.fileExtension

                    })),
                };

            }

            setSubmitLoading(true);
            const endPoint = editData ? ORG_EXPENSE_EDIT_DEL_APPROVE : ORG_ADD_EXCEPTION
            const response = await postData(endPoint, payload);
            const responseData = await response.json();

            if (response.status === 200 && responseData.status_code === 200) {
                if (responseData.message.toLowerCase() === "success") {
                    setSubmitSuccess(responseData.info);
                    setTimeout(() => {
                        setSubmitSuccess('');
                        onValueChange();
                        onClose()
                    }, 2000);
                } else {
                    setSubmitError(responseData?.info || "Failed to delete.");
                    //  Log exception to backend (User Id,Page Name,Method Name,Response)
                    logFrontendException(storedUserId, pageName, "AddExpenseModal", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setSubmitError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "AddExpenseModal", responseData || response || '');

            } else {
                setSubmitError(responseData?.info || "Failed to delete.");
                //  Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "AddExpenseModal", responseData || response || '');
            }
        } catch (err) {
            setSubmitError("Failed to delete.");
            //  Log exception to backend (User Id,Page Name,Method Name,Response)
            logFrontendException(storedUserId, pageName, "AddExpenseModal-catch", err || '');
        } finally {
            setSubmitLoading(false);
        }
    };
    const handleSearchClient = async (uid) => {
        setExpenses((prev) =>
            prev.map((row) =>
                row.uid === uid ? { ...row, clientLoading: true, clientError: "", clientList: [] } : row
            )
        );

        try {
            const row = expenses.find((r) => r.uid === uid);
            const query = row?.clientSearch?.trim();
            if (!query) {
                setExpenses((prev) =>
                    prev.map((row) =>
                        row.uid === uid ? { ...row, clientLoading: false, clientError: "Please enter valid text" } : row
                    )
                );
                return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: query }
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();

            if (response.status === 200 && responseData.statusCode === 200) {
                if (responseData.message.toLowerCase() === "success" && responseData?.dataJ?.length > 0) {
                    setExpenses((prev) =>
                        prev.map((row) =>
                            row.uid === uid
                                ? {
                                    ...row,
                                    clientLoading: false,
                                    clientList: responseData?.dataJ || [],
                                    clientError: responseData?.dataJ.length === 0 ? "No clients found" : ""
                                }
                                : row
                        )
                    );
                } else {
                    setExpenses((prev) =>
                        prev.map((row) =>
                            row.uid === uid ? { ...row, clientLoading: false, clientError: responseData.info || "Failed to load expense types." } : row
                        )
                    );
                    //  Log exception to backend (User Id,Page Name,Method Name,Response)
                    logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setExpenses((prev) =>
                    prev.map((row) =>
                        row.uid === uid ? { ...row, clientLoading: false, clientError: "Unauthorized access. Your session may have expired. Please log in again." } : row
                    )
                );
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || response || '');

            } else {
                setExpenses((prev) =>
                    prev.map((row) =>
                        row.uid === uid ? { ...row, clientLoading: false, clientError: responseData.info || "Failed to load expense types." } : row
                    )
                );
                //  Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || '');

            }


        } catch (err) {
            setExpenses((prev) =>
                prev.map((row) =>
                    row.uid === uid ? { ...row, clientLoading: false, clientError: "Search failed" } : row
                )
            );
            //  Log exception to backend (User Id,Page Name,Method Name,Response)
            logFrontendException(storedUserId, pageName, "handleSearchClient-catch", err || '');
        }
    };

    const handleSelectClient = (uid, client) => {
        setExpenses((prev) =>
            prev.map((row) =>
                row.uid === uid
                    ? {
                        ...row,
                        client: client?.client_id || null,
                        clientSearch: client?.client_name || "",
                        clientList: [],
                        clientError: ""
                    }
                    : row
            )
        );
    };


    const handleOpenSaveModal = () => {
        setSubmitError('')
        if (validateForm()) {
            setIsSaveModalOpen(true);
        }
    }
    const handleCloseSaveModal = () => setIsSaveModalOpen(false);

    const handleOpenCancelModal = () => {
        setIsCancelModalOpen(true);
    }
    const handleCloseCanceleModal = () => setIsCancelModalOpen(false);

    const handleSaveConfirm = async () => {
        setIsSaveModalOpen(false);
        await handleSubmit();

    };

    const handleCancelConfirm = () => {
        setIsCancelModalOpen(false);
        onClose();
    };

    const handleRemoveRow = (uid) => {
        setExpenses((prev) => prev.filter((row) => row.uid !== uid));
    };


    const getStatusStyle = (approval_status_name) => {
        const status = approval_status_name?.toLowerCase();
        switch (status) {
            case "approved":
                return { backgroundColor: "#1A932E2E", color: "#1A932E" };
            case "rejected":
                return { backgroundColor: "#C7C4C32E", color: "#7B7B7B" }; // Gray
            case "approval pending":
                return { backgroundColor: "#EE201C2E", color: "#EE201C" };
            case "partially approved":
                return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
            // return { backgroundColor: "#E65F2B2E", color: "#E65F2B" };
            default:
                return {};
        }
    };


    const isReadOnly = editData?.pageType === 'view' || editData?.pageType === 'approve';
// Fallback message if no approvals yet
if (!expenses.some(row => row?.approvedStatus !== null && row?.approvedStatus !== undefined)) {
    overallStatus = editData?.pageType === 'approve' ? 'approve' : (editData?.pageType === 'edit' ? 'edit' : 'submit');
}
// if(editData?.pageType === 'approve'){
//     console.log('approve:---',overallStatus)
//     // Determine overall status from expenses
//     if (expenses.every(row => row?.approvedStatus === false)) {
//         overallStatus = 'rejecte'; // All Rejected
//         console.log('approve:---',overallStatus)
//     } else if (expenses.every(row => row?.approvedStatus === true && Number(row?.approvedAmount) === Number(row?.amount))) {
//         overallStatus = 'approve'; // All Fully Approved
//     } else if (expenses.every(row => row?.approvedStatus === true && Number(row?.approvedAmount) < Number(row?.amount))) {
//         overallStatus = 'partially approve'; // All Partially Approved
//     } else {
//         // Mixed or partial approvals or some no selection
//         overallStatus = 'partially approve';
//         console.log('approve:---',overallStatus)
//     }
// }
    return (
        <div className="modal-overlay">
            <div className="modal-content" ref={modalRef} style={{
                overflow: shouldScroll ? 'auto' : 'visible',
                maxHeight: '90%', width: "80%"
            }}>
                <button className="close-button" onClick={onClose}>
                    <img src={closeIcon} alt="Close" style={{ width: 15, height: 15 }} />
                </button>

                <h2 className="modal-title">{editData?.pageType === 'view' ? 'View ' : editData?.pageType === 'edit' ? 'Edit ' : editData?.pageType === 'approve' ? 'Approve ' : 'Add '}Expense </h2>
                <hr className="title-divider" />

                <div style={{ display: "flex", gap: "20px", marginBottom: 16, width: '75%', flexWrap: 'wrap' }}>
                    <div>
                        <Input
                            label="Expense Name"
                            placeholder="Enter expense name"
                            value={form.name}
                            onChange={(e) => {
                                setForm({ ...form, name: e.target.value });
                                setErrors((prevErrors) => ({ ...prevErrors, name: '' })); // Clear name error
                            }}
                            searchBoxWidth={260}
                            errorMessage={errors.name}
                            isEdit={!(editData?.pageType === 'view' || editData?.pageType === 'approve')}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Input
                            label="Comment (Optional)"
                            placeholder="Comment"
                            value={form.comment}
                            onChange={(e) => {
                                setForm({ ...form, comment: e.target.value });
                                setErrors((prevErrors) => ({ ...prevErrors, comment: '' })); // Clear comment error
                            }}
                            errorMessage={errors.comment}
                            isEdit={!(editData?.pageType === 'view' || editData?.pageType === 'approve')}
                        />
                    </div>



                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, marginTop: 20 }}>
                    <div style={{ fontWeight: 500 }}>Expenses</div>
                    {!(editData?.pageType === 'view' || editData?.pageType === 'approve') && (
                        <div
                            style={{ cursor: "pointer", color: "#5A55D2", fontSize: "12px", textDecoration: 'underline' }}
                            onClick={handleAddRow}
                        >
                            Add New Expense
                        </div>)}
                </div>

                <div className="table-wrapper table-scroll table-container">
                    <table className="tasksScreen-task-table">
                        <thead>
                            <tr>
                                <th>Nature of Expense</th>
                                <th style={{width:'170px'}}>Expense Type</th>
                                <th>Expense Date</th>
                                <th>Billed to Client</th>
                                <th>Client Name</th>
                                <th style={{ textAlign: 'end', }}>Amount</th>
                                <th>Receipt</th>
                                {(editData?.pageType === 'view' || editData?.pageType === 'approve') && <th style={{ textAlign: 'end', }}>Approved Amount</th>}
                                <th style={{ width: !(editData?.pageType === 'view' || editData?.pageType == 'approve') ? '5px' : null }}></th>
                            </tr>
                        </thead>
                        <tbody style={{ background: '#FFFFFF' }}>
                            {expenses.map((row, index) => (
                                <tr key={row.uid}>
                                    {/* Nature of Expense */}
                                    <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                        {isReadOnly ? row?.nature?.label || '--' : (
                                            <Dropdown
                                                ref={(el) => (dropdownRefs.current[`nature${row.uid}`] = el)}
                                                isOpen={openDropdown === `nature${row.uid}`}
                                                toggleDropdown={() => toggleDropdown(`nature${row.uid}`)}
                                                options={expenseTypeList || []}
                                                value={row?.nature}
                                                onChange={(val) => handleExpenseChangeByUid(row.uid, "nature", val)}
                                                top='100%'
                                                loading={expenseLoading}
                                                errorMessage={row?.rowErrors?.nature || expenseTypeerror}
                                                disabledSelect={true}
                                            />
                                        )}
                                    </td>

                                    {/* Expense Type */}
                                    <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                        {isReadOnly ? row?.type?.label || '--' : (
                                            <Dropdown
                                                ref={(el) => (dropdownRefs.current[`type${row.uid}`] = el)}
                                                isOpen={openDropdown === `type${row.uid}`}
                                                toggleDropdown={() => toggleDropdown(`type${row.uid}`)}
                                                options={expenseTypeOptions}
                                                value={row?.type}
                                                onChange={(val) => handleExpenseChangeByUid(row.uid, "type", val)}
                                                top='100%'
                                                errorMessage={row?.rowErrors?.type}
                                                disabledSelect={true}
                                            />
                                        )}
                                    </td>

                                    {/* Expense Date */}
                                    <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                        {isReadOnly ? <>{row?.date ? convertGMTToLocal(row?.date, 'dd/MM/yyyy') : '--'}</> : (
                                            <DateInput
                                                value={row?.date}
                                                onChange={(e) => handleExpenseChangeByUid(row.uid, "date", e.target.value)}
                                                errorMessage={row?.rowErrors?.date}
                                            // max={new Date().toLocaleDateString("en-CA")}
                                            />
                                        )}
                                    </td>

                                    {/* Billed to Client */}
                                    <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                        {isReadOnly ? (row?.billed?.value ? 'Yes' : 'No') : (
                                            <Dropdown
                                                ref={(el) => (dropdownRefs.current[`billed${row.uid}`] = el)}
                                                isOpen={openDropdown === `billed${row.uid}`}
                                                toggleDropdown={() => toggleDropdown(`billed${row.uid}`)}
                                                options={yesNoOptions}
                                                value={row?.billed}

                                                // options={
                                                //     row?.type?.value === 'self'
                                                //         ? [{ label: "No", value: false }]
                                                //         : yesNoOptions
                                                // }
                                                // // value={row?.billed}
                                                // value={
                                                //     row?.type?.value === 'self'
                                                //         ? { label: "No", value: false }
                                                //         : row?.billed
                                                // }
                                                onChange={(val) => handleExpenseChangeByUid(row.uid, "billed", val)}
                                                top='100%'
                                                errorMessage={row?.rowErrors?.billed}
                                                disabledSelect={true}
                                                
                                            />
                                        )}
                                    </td>

                                    {/* Client Name */}
                                    <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px', width: '15%' }}>
                                        {isReadOnly ? row?.clientSearch || '--' : (
                                            <div className="filter-field" style={{ width: '100%',zIndex:'inherit' }}>
                                                <TextInput
                                                    type="text"
                                                    placeholder="Client Name"
                                                    value={row?.clientSearch}
                                                    onChange={(e) => handleExpenseChangeByUid(row.uid, "clientSearch", e.target.value)}
                                                    onRightClick={() => handleSearchClient(row.uid)}
                                                    right={
                                                        row?.clientLoading ? (
                                                            <Loader loading={true} color={'var(--primary-loader-color)'} size="small" />
                                                        ) : (
                                                            <img src={searchIcon} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                                        )
                                                    }
                                                    style={{padding: '20px 10px'}}
                                                    errorMessage={row?.clientError || row?.rowErrors?.clientSearch}
                                                    // disabled={!row?.billed?.value}
                                                    isEdit={row?.billed?.value}
                                                />
                                                {row?.clientList?.length > 0 && (
                                                    <ul style={styles.dropdownList}>
                                                        {row?.clientList?.map((client, index) => (
                                                            <li
                                                                key={client?.client_id}
                                                                onClick={() => handleSelectClient(row?.uid, client)}
                                                                style={{
                                                                    ...styles.dropdownItem,
                                                                    borderBottom: index !== row?.clientList?.length - 1 ? '1px solid #ccc' : 'none',
                                                                }}
                                                            >
                                                                {client?.client_name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        )}
                                    </td>

                                    {/* Amount */}
                                    <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                        {isReadOnly ? <div style={{ textAlign: 'end' }}>{row?.amount ? Number(row?.amount).toFixed(2) : '0.00'}</div> : (
                                            <Input
                                                inputType="number"
                                                value={row?.amount}
                                                onChange={(e) => handleExpenseChangeByUid(row.uid, "amount", e.target.value)}
                                                style={{ textAlign: 'end' }}
                                                errorMessage={row?.rowErrors?.amount}
                                                maxLength={10}
                                            />
                                        )}
                                    </td>

                                    {/* Receipt View/Upload */}
                                    <td style={{ overflow: 'visible', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                        {row.uploaded ? (<>
                                            <span
                                                style={{ color: "#5A55D2", cursor: "pointer" }}
                                                onClick={() => {
                                                    const isURL = row?.base64File?.startsWith("http");

                                                    if (isURL) {
                                                        const fileURL = row?.base64File;
                                                        const isPDF = fileURL.toLowerCase().includes(".pdf");

                                                        const win = window.open("", "_blank", "width=800,height=600,resizable=yes");
                                                        win.document.write(`
                                                    <html>
                                                    <head>
                                                        <title>Receipt Viewer</title>
                                                        <style>
                                                        body {
                                                            margin: 0;
                                                            padding: 0;
                                                            background: #000;
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: center;
                                                            height: 100vh;
                                                        }
                                                        img, iframe, embed {
                                                            max-width: 100%;
                                                            max-height: 100vh;
                                                            border: none;
                                                        }
                                                        embed {
                                                            width: 100vw;
                                                            height: 100vh;
                                                        }
                                                        </style>
                                                    </head>
                                                    <body>
                                                        ${isPDF
                                                                ? `<embed src="${fileURL}" type="application/pdf" />`
                                                                : `<img src="${fileURL}" alt="Receipt" />`}
                                                    </body>
                                                    </html>
                                                `);
                                                    } else {
                                                        // Base64 block
                                                        const fileType = row?.file?.type || "application/octet-stream";
                                                        const base64 = row?.base64File;
                                                        const dataUrl = `data:${fileType};base64,${base64}`;
                                                        const isPDF = fileType === "application/pdf";
                                                        const win = window.open("", "_blank", "width=800,height=600,resizable=yes");
                                                        win.document.write(`
                                                    <html>
                                                    <head>
                                                        <title>Receipt Viewer</title>
                                                        <style>
                                                        body {
                                                            margin: 0;
                                                            padding: 0;
                                                            background: #000;
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: center;
                                                            height: 100vh;
                                                        }
                                                        img, iframe, embed {
                                                            max-width: 100%;
                                                            max-height: 100vh;
                                                            border: none;
                                                        }
                                                        embed {
                                                            width: 100vw;
                                                            height: 100vh;
                                                        }
                                                        </style>
                                                    </head>
                                                    <body>
                                                        ${isPDF
                                                                ? `<embed src="${dataUrl}" type="application/pdf" />`
                                                                : `<img src="${dataUrl}" alt="Receipt" />`}
                                                    </body>
                                                    </html>
                                                `);
                                                    }
                                                }}
                                            >
                                                View
                                            </span>

                                        </>
                                        ) : (<>
                                            {(editData?.pageType !== 'view' && editData?.pageType !== 'approve') ? (
                                                row?.expenseUid ? '--' : (
                                                    <label style={{ color: "#5A55D2", cursor: "pointer" }}>
                                                        Upload
                                                        <input
                                                            type="file"
                                                            accept=".pdf,.jpg,.jpeg,.png"
                                                            style={{ display: "none" }}
                                                            onChange={(e) => handleFileUpload(row.uid, e.target.files[0])}
                                                        />
                                                    </label>
                                                )
                                            ) : '--'}
                                        </>
                                        )}
                                    </td>

                                    {/* Approved Amount (only in view/approve mode) */}
                                    {(editData?.pageType === 'view' || editData?.pageType === 'approve') && (
                                        <td style={{ overflow: 'visible', verticalAlign: isReadOnly ? '':'top', padding: isReadOnly ? '10px 12px' : '2px 12px' }}>
                                            {editData?.pageType === 'view' ? (
                                                <div style={{ textAlign: 'end' }}>{row?.approvedAmount ? Number(row?.approvedAmount).toFixed(2) : '0.00'}</div>
                                            ) : (
                                                <Input
                                                    inputType="number"
                                                    value={row?.approvedAmount ?? ''}
                                                    onChange={(e) => handleExpenseChangeByUid(row.uid, "approvedAmount", e.target.value)}
                                                    style={{ textAlign: 'end' }}
                                                    errorMessage={row?.rowErrors?.approvedAmount}
                                                    maxLength={10}
                                                />
                                            )}
                                        </td>
                                    )}

                                    {/* Approve/Reject or Remove */}
                                    <td style={{ textAlign: "center" }}>
                                        {editData?.pageType === 'view' && (
                                            <div style={{ padding: "3px 10px", width: 'fit-content', borderRadius: "20px", fontSize: 10, ...getStatusStyle(row?.expense_status_name) }}>
                                                {row?.expense_status_name}
                                            </div>
                                        )}

                                        {editData?.pageType === 'approve' && (
                                            <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                                                <img
                                                    src={row?.approvedStatus === true ? approvedIcon : approveIcon}
                                                    alt="Approve"
                                                    onClick={() => {
                                                        // Check if approvedAmount is empty or > 0
                                                        // if (!row.approvedAmount || Number(row.approvedAmount) > 0) {
                                                        handleExpenseChangeByUid(row.uid, 'approvedStatus', true);
                                                        // }
                                                    }}
                                                    style={{
                                                        width: 18,
                                                        height: 18,
                                                        // cursor: (!row.approvedAmount || Number(row.approvedAmount) > 0) ? 'pointer' : 'not-allowed',
                                                        // opacity: (!row.approvedAmount || Number(row.approvedAmount) > 0) ? 1 : 0.3,
                                                        cursor: 'pointer',
                                                        opacity: 1,
                                                    }}
                                                    title="Approve"
                                                />

                                                <img
                                                    src={row?.approvedStatus === false ? rejectedIcon : rejectIcon}
                                                    alt="Reject"
                                                    onClick={() => handleExpenseChangeByUid(row.uid, 'approvedStatus', false)}
                                                    style={{
                                                        width: 18,
                                                        height: 18,
                                                        cursor: 'pointer',
                                                    }}
                                                    title="Reject"
                                                />
                                            </div>
                                        )}

                                        {!(editData?.pageType === 'view' || editData?.pageType === 'approve') && (!row.expenseUid && expenses.length !== 1) && (
                                            <span
                                                style={{
                                                    color: "red",
                                                    cursor: "pointer",
                                                    fontSize: 16,
                                                    fontWeight: "bold",
                                                }}
                                                onClick={() => handleRemoveRow(row.uid)}
                                                title="Remove this row"
                                            >
                                                ×
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}

                            {/* Total Row */}
                            <tr style={{ background: '#EDF1D6' }}>
                                <td colSpan="5" style={{ paddingLeft: 25, fontWeight: 600 }}> Total</td>
                                <td style={{ fontWeight: "bold", textAlign: 'end' }}>{total.toFixed(2)}</td>
                                <td />
                                {(editData?.pageType === 'view' || editData?.pageType === 'approve') && (
                                    <td style={{ fontWeight: "bold", textAlign: 'end' }}> {approvedTotal.toFixed(2)}</td>
                                )}
                                <td />
                            </tr>
                        </tbody>

                    </table>
                </div>
                {submitSuccess && <div className="list-success-msg">{submitSuccess}</div>}
                {submitError && <div className="list-error-msg">{submitError} </div>}
                {expenseOpeningInfoError && <div className="list-error-msg">{expenseOpeningInfoError} </div>}
                {editData?.pageType !== 'view' && (
                    <div style={styles.buttonContainer}>
                        <button
                            className="add-client-button"
                            style={{ paddingLeft: 30, paddingRight: 30, opacity: submitLoading || !isExpOpeningBalAvailable ? 0.5 : 1 , cursor: submitLoading || editData?.pageType === 'view' || !isExpOpeningBalAvailable ? "not-allowed" : "pointer" }}
                            disabled={submitLoading || editData?.pageType === 'view' || !isExpOpeningBalAvailable}
                            onClick={handleOpenSaveModal}
                        >
                            <span style={{ paddingRight: submitLoading ? 10 : 0 }}>
                                <Loader loading={submitLoading} color="#FFFFFF" size="small" />
                            </span>
                            {editData?.pageType === 'edit' ? 'Update Expense' : editData?.pageType === 'view' ? 'Submit' : 'Submit Expense'}
                        </button>
                        <button className="cancel-button" onClick={handleOpenCancelModal}>
                            Cancel
                        </button>
                    </div>
                )}
                <DeleteConfirmationModal
                    isOpen={isSaveModalOpen}
                    message={
                        editData?.pageType === 'approve'
                            ? "Are you sure you want to continue with this expense approval action?"
                            : `Are you sure you want to ${overallStatus} this expense?`
                    }
                    onClose={handleCloseSaveModal}
                    onConfirm={() => { handleSaveConfirm() }}
                />
                <DeleteConfirmationModal
                    isOpen={isCancelModalOpen}
                    message={`Are you sure you want to cancel this expense ?`}
                    onClose={handleCloseCanceleModal}
                    onConfirm={() => { handleCancelConfirm() }}
                />
            </div>
        </div>
    );
};

const styles = {
    buttonContainer: {
        display: "flex",
        gap: "12px",
        justifyContent: "flex-start",
        marginTop: "20px",
    },
    dropdownList: {
        position: 'absolute',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0,
        margin: 0,
        listStyleType: 'none',
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        backgroundColor: '#fff',
    },
    arrowBtn: {
        marginRight: "5px",
        cursor: "pointer",
        width: "28px",
        height: "28px",
    },

};

export default AddExpenseModal;
